import {
  canTakeDesktopControl,
  showsDesktopStatusBar,
  type DesktopPanelCopy,
  type DesktopPanelState,
} from "./desktopPanelState";

/**
 * What floats ON the stream: the pre-stream status, and control.
 *
 * Kept out of DesktopPanel because it is pure presentation over one state
 * value, and because the panel sits under a file-size ratchet that only turns
 * one way — growth there has to become extraction somewhere.
 *
 * Control is centred while watching and moves to the bottom edge while driving,
 * so the pill never sits under the pointer you are about to use.
 */
export function DesktopSurfaceOverlay(props: {
  readonly state: DesktopPanelState;
  readonly copy: DesktopPanelCopy;
  readonly controlling: boolean;
  readonly onControlChange: (held: boolean) => void;
}) {
  return (
    <>
      {showsDesktopStatusBar(props.state) ? null : (
        <div
          data-testid="desktop-connecting-status"
          role="status"
          aria-live="polite"
          className="pointer-events-none absolute inset-0 z-10 flex items-center justify-center p-4 text-center"
        >
          <div className="rounded-[var(--control-radius)] border border-border bg-card px-4 py-3 shadow-xs">
            <div className="flex items-center justify-center gap-2">
              <span
                aria-hidden
                className="size-1.5 shrink-0 rounded-full bg-info animate-status-pulse"
              />
              <div className="text-sm font-medium text-foreground">{props.copy.title}</div>
            </div>
            <div className="mt-1 text-sm text-muted-foreground md:text-xs">{props.copy.detail}</div>
          </div>
        </div>
      )}
      {canTakeDesktopControl(props.state) && !props.controlling ? (
        <button
          type="button"
          data-testid="desktop-take-control"
          onClick={() => {
            props.onControlChange(true);
          }}
          className="absolute left-1/2 top-1/2 z-20 inline-flex h-8 -translate-x-1/2 -translate-y-1/2 items-center rounded-md bg-foreground px-3 text-xs font-medium text-background transition-opacity hover:opacity-90"
        >
          Take control
        </button>
      ) : null}
      {props.controlling ? (
        <button
          type="button"
          data-testid="desktop-release-control"
          onClick={() => {
            props.onControlChange(false);
          }}
          className="absolute bottom-3 left-1/2 z-20 inline-flex h-7 -translate-x-1/2 items-center gap-1.5 rounded-md border border-border/50 bg-popover px-2.5 text-xs font-medium text-info-foreground transition-colors hover:border-border/70"
        >
          <span aria-hidden className="size-1.5 rounded-full bg-info animate-status-pulse" />
          Release control
        </button>
      ) : null}
    </>
  );
}
